import { UserExperienceSensorModeKind } from '@src/types'

export const OWN_SENSOR_MODES = [
  UserExperienceSensorModeKind.OwnSensorDexcomG6,
  UserExperienceSensorModeKind.OwnSensorDexcomG7,
  UserExperienceSensorModeKind.OwnSensorDexcomStelo,
  UserExperienceSensorModeKind.DexcomStelo,
  UserExperienceSensorModeKind.OwnSensorLibre1,
  UserExperienceSensorModeKind.OwnSensorLibre2,
  UserExperienceSensorModeKind.OwnSensorLibre3,
]
